// ModalButtonSection.jsx

import React from 'react';

// CSS
import './ModalButtonSection.css';

/**
 * ModalButtonSection Component
 * 
 * This component renders a section container for modal buttons.
 * 
 * @param {string} align - Alignment for the buttons, either 'START' or 'END'. Defaults to 'END'.
 * @param {JSX.Element} children - The children to render.
 * 
 * @returns {ReactNode} The rendered component.
 */
const ModalButtonSection = ({ align = 'END', children }) => {

  // ----- RENDER ----- //

  return (
    <>
      <div
        className="modal-button-section-container"
        style={{
          justifyContent: align === 'START' ? 'flex-start' : 'flex-end',
        }}
      >
        {children}
      </div>
    </>
  );
};

// Dev Tools
ModalButtonSection.displayName = 'ModalButtonSection';

export default ModalButtonSection;
